import { httpClient } from '@/services/http/httpClient'

type Category = {
  value: string
  label: string
}

export async function getCategoriesArticles(): Promise<{
  categories: Category[]
}> {
  const { data } = await httpClient.get('/users/videos/articles/categories')

  return { categories: data.categories }
}
